import {
  ContractTypeTreeSelect,
  ContractTypeTreeSelectProps,
} from "../../../../../-components/contract-type-tree-select"
import { ContractTypeCategoryIdOrContractTypeId } from "../../../../../@client/Theasoft_Absences_Config"

const map = {
  treeNodeIdToContractTypeCategoryOrContractTypeId: (id: string) => {
    const values = id.split("-")
    const c = values[0]
    if (c !== "ContractTypeCategoryId" && c !== "ContractTypeId") {
      throw new Error(
        `id must be ContractTypeCategoryId or ContractTypeId but got ${c}`
      )
    }
    const field = parseInt(values[1])
    if (isNaN(field)) {
      throw new Error(`expected a number but got ${values[1]}`)
    }
    return {
      Case: c,
      Fields: field,
    } satisfies ContractTypeCategoryIdOrContractTypeId
  },
  contractTypeCateryOrContractTypeIdToNodeId: (
    v: ContractTypeCategoryIdOrContractTypeId
  ) => `${v.Case}-${v.Fields}`,
}

export function ContractTypeOrCategorySelect({
  initialCheckedState,
  onCheckedStateChange,
  ...props
}: Omit<
  ContractTypeTreeSelectProps,
  "onCheckedStateChange" | "initialCheckedState"
> & {
  initialCheckedState: ContractTypeCategoryIdOrContractTypeId[]
  onCheckedStateChange: (v: ContractTypeCategoryIdOrContractTypeId[]) => void
}) {
  const selected = initialCheckedState.map(
    map.contractTypeCateryOrContractTypeIdToNodeId
  )
  return (
    <ContractTypeTreeSelect
      {...props}
      initialCheckedState={selected}
      onCheckedStateChange={(v) => {
        const values = v.map(
          map.treeNodeIdToContractTypeCategoryOrContractTypeId
        )
        onCheckedStateChange(values)
      }}
    />
  )
}
